export const resolveCreationErrorMessage = (error: unknown): string =>
  error instanceof Error
    ? error.message
    : 'Erreur inconnue lors de la création.';
